<script setup lang="ts">
import { useModel } from './../model/model'
import ObjectSearchList from './ObjectSearchList.vue'
import { computed, ref, watch } from 'vue'
import type { ObjectSearchType } from '@/widgets/ObjectSearch/model/types'
import { useGetSearchObject } from '@/widgets/ObjectSearch/model/api'
import { VTextField } from 'vuetify/components'

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  object_type: {
    type: Number,
    required: false,
    default: 0,
  },
  fixed_height: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  mock: {
    type: Boolean,
    default: false,
  },
})

const model = defineModel()
const { search, list, isLoading, clearHandler, reloadData } = useModel(Number(props.object_type), props.mock)
const result = ref<string>(search.value)
const visible = ref<boolean>(false)

/**
 * Обрабатываем выбор элемента списка
 * @param item
 */
const selectHandler = (item: ObjectSearchType) => {
  result.value = item.name
  search.value = ''
  list.value = []
  visible.value = false

  model.value = item.id
}

/**
 * Загрузка сохраненной группы при создании компонента
 */
const { data } = useGetSearchObject(model)

watch(data, () => {
  result.value = typeof data.value?.data == 'string' ? data.value?.data : String(model.value)
})

/* Обработка появления/исчезновения строки поиска */
const clickHandler = () => {
  visible.value = true
}

const clickOutsideHandler = () => {
  clearHandler()
  visible.value = false
}

/**
 * Вычисляем высоту окна при фиксированном значении
 * реализовано для отображения результата при выводе в модальном окне
 */
const fixedHeight = computed(() => {
  if (!list.value.length || !props.fixed_height) return 'auto'

  if (list.value.length >= 5) {
    return '250px'
  } else {
    return 15 + list.value.length * 44 + 'px'
  }
})
</script>

<template>
  <div class="object-search" v-click-outside="clickOutsideHandler">
    <VTextField v-model="result" :label readonly @click="clickHandler" :disabled />

    <div :style="{ height: fixedHeight }">
      <ObjectSearchList :list="list" @selected="selectHandler" :with-search="visible">
        <template #search_field>
          <VTextField
            v-model="search"
            @input="reloadData"
            :loading="isLoading"
            :placeholder="$t('itf.search_label', { num: 3 })"
            hide-details
            autofocus
          />
        </template>
      </ObjectSearchList>
    </div>
  </div>
</template>
